<template>
  <div class="report-table">
    <div class="container">
      <div class="container-body">
        <div class="inline-left" v-if="this.$route.query.excel == 1">
          <p class="title">上传《湖南辖区私募基金管理人季度报表》</p>
          <p class="content">填写完毕后点击【数据上传】</p>
          <div class="update">
            <!-- <el-input v-model="str" :disabled="true"></el-input> -->

            <div class="uploadBtn">
              <a href="javascript:void(0);" class="input">
                数据上传
                <input
                  :key="this.$route.query.step"
                  type="file"
                  class="file"
                  @change="uploadExcelToSave($event)"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="inline-right">
          <p class="title">提交盖章文件</p>
          <p class="content">季报打印盖章后，上传并提交即可完成填报</p>
          <div class="update">
            <div class="uploadBtn">
              <a href="javascript:void(0);" class="input gz">
                上传盖章文件
                <input
                  type="file"
                  class="file"
                  @change="getFile($event)"
                  accept="application/pdf,image/*,application/x-zip-compressed,application/x-rar-compressed"
                />
              </a>
            </div>
            <!-- <el-button type="primary" plain>上传盖章报表</el-button> -->
          </div>
          <div class="agree">
            <el-checkbox v-model="checked">{{ text }}</el-checkbox>
          </div>
          <div class="btnGroup">
            <el-button @click="pre">上一步</el-button>
            <el-button type="primary" @click="submitFile" class="mainBtn">提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import comMixin from 'common/js/mixin/comMixin'
import {
  singleUploadQuarter,
  getReportDetail,
  reportFileSave,
  reportExport,
  submitReport,
  uploadExcelToSave,
  dataSourceTemplate
} from 'common/js/api'

export default {
  mixins: [comMixin],

  data() {
    return {
      checked: true,
      uploadFile: '',
      storePath: '',
      text: `我企业承诺不从事非法集资等违法违规行为，并且承诺所提供信息真实、完整,不存在任何虚假记载、误导性陈述或重大遗漏，并愿意承担全部的法律责任。`,
      step: 1,
      codeId: this.$route.query.codeId,
      qrbasic: {},
      str: '文件模板',
      institutionName: ''
    }
  },

  mounted() {
    this.getReportName()
  },

  methods: {
    async getFile(event) {
      if (!this.checked) {
        this.$message({
          message: '请仔细阅读法律协议,同意后才能进行此操作',
          type: 'warning'
        })
        return
      }
      let file = event.target.files[0]
      let fileName = file.name
      if (file) {
        let idx = fileName.lastIndexOf('.')
        if (idx != -1) {
          let ext = fileName.substr(idx + 1).toUpperCase()
          ext = ext.toLowerCase()
          if (ext != 'pdf' && ext != 'rar' && ext != 'zip') {
            this.$message.error('请上传格式正确的文件，支持pdf、rar和zip')
          } else {
            this.file = file
            if (this.file) {
              const res = await this.submitUpload(event)
              this.uploadFile = res.result.orignName
              this.storePath = res.result.storePath
            }
          }
        }
      }
    },

    async submitUpload(event) {
      event.preventDefault()
      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('institutionName', this.institutionName)
      //盖章文件使用类型A
      const result = await singleUploadQuarter(formData, 'A')
      this.$message({
        message: '上传成功',
        type: 'success'
      })
      return result
    },

    async submitFile() {
      const data = {
        reportCode: this.codeId,
        reportFileName: this.uploadFile,
        storePath: this.storePath
      }
      const res = await reportFileSave(data)
      //季报路径以及文件名存表
      await submitReport(this.codeId)
      this.$message({
        message: '信息表提交成功!',
        type: 'success'
      })
      this.$router.replace({
        path: this.$route.path,
        query: {
          flag: this.$route.query.flag,
          codeId: this.codeId,
          step: this.step + 1
        }
      })
      this.$emit('next', this.codeId)
    },

    async save() {
      return true
    },

    async download() {
      await reportExport(this.codeId)
    },

    async getReportName() {
      const res = await getReportDetail(this.codeId)
      this.institutionName = res.result.basic.institutionName

      this.qrbasic = res.result.basic
    },

    async uploadExcelToSave(event) {
      console.log('@file', event.target.files[0])
      let formData = new FormData()
      formData.append('file', event.target.files[0])
      const res = await uploadExcelToSave(this.codeId, this.qrbasic.reportFillType, formData)
      if (res.code == 200) {
        this.$message({
          message: '信息表提交成功!',
          type: 'success'
        })
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },

    async dataSourceTemplate() {
      console.log('wojinlaile')
      await dataSourceTemplate(this.qrbasic.reportFillType)
    }
  }
}
</script>

<style scoped lang="scss">
.report-table {
  text-align: center;
  /* margin-top: 10%; */
}
.el-checkbox ::v-deep  .el-checkbox__label {
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap !important;
  vertical-align: top;
  width: 500px !important;
  font-size: 14px !important;
  color: #b6bcc2 !important;
  letter-spacing: 0 !important;
  line-height: 18px !important;
}
.title {
  font-size: 24px;
  color: #0f1824;
  padding-bottom: 20px;
}
.content {
  font-size: 16px;
  color: #b6bcc2;
  padding-bottom: 20px;
}
.agree {
  /* padding-top: 20px; */
  margin: 60px 0px 30px 0px;
}

.update {
  margin-bottom: 10px;
  position: relative;
}

.uploadBtn {
  border-radius: 4px;
  padding: 12px 20px;
  position: relative;
  display: inline-block;
  width: 110px;
  height: 40px;
  color: #fff;
  background: #3099fc;
  border: 1px solid #c8d5e2;
  vertical-align: middle;
  outline: none;
}
.uploadBtn:hover {
  background: #3099fc;
  border-color: #3099fc;
  color: #fff;
}
.uploadBtn:hover a {
  color: #fff !important;
}

.update ::v-deep  .el-input {
  width: 25% !important;
  border: none !important;
  background: #e4e7ed !important;
  height: 32px !important;
  line-height: 32px !important;
  margin-right: 15px;
}
.update ::v-deep  .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
.download {
  margin-right: 10px;
}
/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  /* border-radius: 5px; */
  // margin-top: 1px;
  vertical-align: top;
  // line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #fff;
  position: absolute !important;
  right: 25px;
  top: 0px;
}
a.gz {
  right: 13px;
}
.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
.el-checkbox {
  color: #b6bcc2;
}
.el-checkbox ::v-deep  .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #3165ff;
}

.inline-left {
  width: 700px;
  padding-bottom: 20px;
  display: inline-block;
}
.inline-right {
  width: 700px;
  padding-bottom: 20px;
  display: inline-block;
}
.container {
  &-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
